import { useEffect, useState } from 'react';

/** Valore ritardato (es. ricerca testo) per evitare fetch ad ogni tasto. */
export default function useDebouncedValue(value, delayMs = 300) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return debounced;
}
